export default {
  CASE_DETAILS: {
    OK: 'OK',
    CASE_ID: 'Case ID:',
    COPIED: 'Copied',
    COPIED_VALUE: 'Copied: {{value}}',
    COPIED_LABELED: '{{label}} copied: {{value}}',
    COPY: 'Copy',
    DEBTOR_DATA: {
      TITLE: 'Customer',
      NAME_LABEL: 'Customer name',
      ADDRESS_LABEL: 'Customer address',
      EMAIL_LABEL: 'Customer email address',
      PHONE_LABEL: 'Customer phone no.',
    },
    LEGAL: {
      TITLE: 'Proof of legal relationship',
      FILES_LABEL: 'Uploaded files',
      DESCRIPTION_LABEL: 'Description',
    },
    BAILIFF_CONTACT: {
      TITLE: 'Bailiff contact',
    },
    CLAIMS: {
      TITLE: 'Claims',
      TOTAL_LABEL: 'Sum of claims',
      CAPITAL_CLAIMS: {
        TITLE: 'Principal claims:',
        INDEX: '{{index}}. claim',
        DUE_DATE_LABEL: 'Due date:',
        FILE_TITLE: 'Uploaded:',
        TOTAL_LABEL: 'Sum of principal claims',
      },
      OPTIONAL_CLAIMS: {
        TITLE: 'Related claims:',
        TOTAL_LABEL: 'Sum of related claims',
      },
    },
    DOCUMENTS: {
      TITLE: 'Documents, identifiers',
      PROFORMA_LABEL: 'Proforma invoice',
      INVOICE_LABEL: 'Invoice',
      EXTERNAL_IDS_LABEL: 'Case numbers',
      PAYEE_ID_LABEL: 'Payee case identifier',
      PAYEE_ID_TOOLTIP:
        'The case identifier generated by Payee; please refer to it when contacting our customer service.',
      OFP_ID_TOOLTIP:
        'The case number assigned by the notary to the order for payment procedure. You do not need to do anything with it; we show it for reference.',
      DOWNLOAD: 'Download',
      EXTERNAL_ID_TYPE: {
        ofp: 'Order for payment case number',
        enforcement: 'Enforcement case number',
        bailiff: 'Bailiff identifier',
      },
    },
    HISTORY: {
      TITLE: 'Case history',
      STARTED_AT: 'Started at:',
    },
    ERROR_MESSAGES: {
      UNKNOWN_ERROR_WHILE_LOADING_DETAILS: 'Error while loading the events! Please try again.'
    }
  },
};